<template>
    <div id="return-date-modal" class="modal fade" role="dialog"  data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">{{trans('step1.choose_your_return_date','Choose Your Return Date')}}</h4>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="saveReturnData" method="POST">
                        <div class="row">
                            <div class="text-center">
                                <return-date-picker/>
                                <p v-if="!form.return_date && form_submitted" class="text-danger">{{trans('step1.plz_select_return_date','Please Select Your Return Date.')}}</p>
                            </div>
                        </div>
                        <div class="row m-t-20">
                            <div class="col-sm-12">
                                <p class="h6 v-centered">{{trans('step1.return_description','Please select your last day of skiing. We will pick up your equipment from your accommodations at the end of your final ski day.')}}</p>
                            </div>
                            <div class="col-sm-6">
                                <p class="text-right" style="padding-top: 12px;">{{trans('step1.min_booking_day',min_booking_days+1 +' - Day Minimum',min_booking_days+1)}}</p>
                            </div>
                            <div class="col-sm-6">
                                <button type="submit" id="return-modal-next-button" class="btn btn-blue btn-cart-md">{{ fromDetailBar ? trans('general.save','Save') : trans('general.next','Next') }}</button>
                            </div>
                        </div>
                    </form>
                    <div class="overlay-loader" v-if="isLoading">
                        <i class="overlay-img-load"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapState, mapActions} from "vuex";
import ReturnDatePicker from "../ReturnDatePicker";
export default {
    props: ['fromDetailBar','fromWp'],
    name: 'ReturnDateModal',
    components: {ReturnDatePicker},
    computed:{
        step1_completed(){
            return (this.form.resort_id && this.form.delivery_date && this.form.delivery_time && this.form.return_date)
        },
        route_name(){
            if(this.fromWp){
                if(this.step === 1){
                    return 'Step1';
                }else{
                    return 'Step2';
                }
            }else{
                return this.$route.name;
            }
        },
        ...mapState(['resort_is_krf', 'form','min_booking_days', 'isLoading', 'step']),
    },
    data(){
        return{
            form_submitted: false
        }
    },
    methods: {
        trans(key, defaultValue, msg = null) {
            let translation = '';
            if (msg) {
                translation = this.$t(key, {message: msg});
            } else {
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
        saveReturnData() {
            let _this = this;
            this.form_submitted = true;

            if (_this.step1_completed) {
                _this.saveStep1();
                $('.close').click();
            }
        },

        saveStep1() {
            let _this = this;
            // _this.$store.state.coupon = null;
            // _this.$store.dispatch('applyGlobalCoupon');
            if(_this.route_name === 'Step1' || _this.route_name === 'Step_1' || _this.route_name === 'Step1Portal'){
                if(_this.fromWp){
                    this.updateStep({'step': 2});
                    this.putDataInStorage()
                    this.$forceUpdate();
                }else{
                    this.putDataInStorage();
                    _this.$router.push({name : 'Step2'});
                }
            }else{
                //step 2 re-render
                _this.$store.dispatch('fetchPackages', {'fromDetailBar': _this.fromDetailBar})

            }

        },

        ...mapActions(['updateStep','putDataInStorage']),
        ...mapGetters(['getRentalLength', 'getLimitationAge']),
    }
}
</script>
<style scoped>
.v-centered {
    margin-top: 0;
    margin-bottom: 20px
}
@media only screen and (max-width: 768px) {
    .v-centered {
        margin-top: 0;
        margin-bottom: 0
    }
}
</style>
